import React from "react";
import PropTypes from "prop-types";
import { ContentWithImage, Headline, SectionContent, Text } from "../common";
import * as S from "./Vantagens.Style";

const VantagemItem = ({ titulo, children }) => (
  <>
    <S.TitleText bodyStrong as={Text} text={titulo} />
    <Text>{children}</Text>
  </>
);

VantagemItem.propTypes = {
  titulo: PropTypes.string.isRequired,
};

const Vantagens = (props) => {
  const { reverse, imgSrc, imgAlt, titulo, description, children } = props;
  return (
    <>
      <SectionContent>
        <ContentWithImage
          reverse={reverse}
          imgColumnSize={5}
          imgSrc={imgSrc}
          imgAlt={imgAlt}
        >
          <Headline nivel="2" styleAs="4" text={titulo} />
          <S.SubtitleSection as={Text} bodyStrong>
            {description}
          </S.SubtitleSection>

          {children}
        </ContentWithImage>
      </SectionContent>
    </>
  );
};

Vantagens.defaultProps = {
  reverse: false,
};

Vantagens.propTypes = {
  reverse: PropTypes.bool,
  imgSrc: PropTypes.string.isRequired,
  imgAlt: PropTypes.string.isRequired,
  titulo: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
};

Vantagens.Vantagem = VantagemItem;

export default Vantagens;
